

export const anyHasValue = (values : String[]) => {
  return values.some(val => val.length > 0)
}

export const allHasValue = (values: String[]) => {
  return !values.some(val => val.length === 0);
}
